/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Endtimemustbeafterstarttime6Inputs */

const en_endtimemustbeafterstarttime6 = /** @type {(inputs: Endtimemustbeafterstarttime6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`End time must be after start time`)
};

const de_endtimemustbeafterstarttime6 = /** @type {(inputs: Endtimemustbeafterstarttime6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Die Endzeit muss nach der Startzeit liegen`)
};

/**
* | output |
* | --- |
* | "End time must be after start time" |
*
* @param {Endtimemustbeafterstarttime6Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const endtimemustbeafterstarttime6 = /** @type {((inputs?: Endtimemustbeafterstarttime6Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Endtimemustbeafterstarttime6Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_endtimemustbeafterstarttime6(inputs)
	return de_endtimemustbeafterstarttime6(inputs)
});
export { endtimemustbeafterstarttime6 as "endTimeMustBeAfterStartTime" }